import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Wrench, BookOpen, BookMarked, Phone } from "lucide-react";

const NAV_ITEMS = [
  { path: "/", icon: Home, label: "Inicio", testid: "nav-home" },
  { path: "/tools", icon: Wrench, label: "Herramientas", testid: "nav-tools" },
  { path: "/library", icon: BookOpen, label: "Biblioteca", testid: "nav-library" },
  { path: "/journal", icon: BookMarked, label: "Diario", testid: "nav-journal", badge: true },
  { path: "/support", icon: Phone, label: "Apoyo", testid: "nav-support" },
];

function hasTodayEntry() {
  try {
    const entries = JSON.parse(localStorage.getItem("reconectados_journal") || "[]");
    const today = new Date().toDateString();
    return entries.some(e => new Date(e.date).toDateString() === today);
  } catch { return false; }
}

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [journalPending, setJournalPending] = useState(false);

  useEffect(() => {
    setJournalPending(!hasTodayEntry());
    const interval = setInterval(() => setJournalPending(!hasTodayEntry()), 30000);
    return () => clearInterval(interval);
  }, [location.pathname]);

  if (location.pathname === "/crisis") return null;

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] bg-white/95 backdrop-blur-xl border-t border-[#E4EBE6] z-40"
    >
      <div className="flex items-stretch justify-around px-1 py-1.5">
        {NAV_ITEMS.map(({ path, icon: Icon, label, testid, badge }) => {
          const isActive = location.pathname === path;
          const showBadge = badge && journalPending && !isActive;
          return (
            <button
              key={path}
              data-testid={testid}
              onClick={() => navigate(path)}
              className={`relative flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 rounded-xl transition-all duration-200 ${
                isActive
                  ? "bg-[#EEF4F1] text-[#6B9080]"
                  : "text-[#2C4238] hover:text-[#6B9080] hover:bg-[#F7F9F7]"
              }`}
            >
              <div className="relative">
                <Icon size={18} strokeWidth={isActive ? 2.5 : 1.8} />
                {showBadge && (
                  <div className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-[#E07A5F]" />
                )}
              </div>
              <span className={`text-[9px] leading-none ${isActive ? "font-bold" : "font-medium"}`}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
